import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker with safe update handling
// CRITICAL: Do NOT auto-reload on update - this causes infinite loops on mobile PWA
serviceWorkerRegistration.register({
  onSuccess: () => {},
  onUpdate: (registration) => {
    // Skip waiting so new service worker activates
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
    // Log update but DO NOT auto-reload - user will get update on next visit
  }
});
